// extracted by mini-css-extract-plugin
export default {"container":"styles-module__container__src-labstep-web-grid-NewIndex-coldefs-metadata-_VqE5k"};